var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import Popover from '../../components/popover';
import Button from '../button';
import Icon from '../icon';
import popupHelper from './popup';
/**
 * Used by the original style of authenticated apps
 * e.g. Gallery for Instagram, Google Slides etc?
 * i.e. type = "external" in old registry (i.e. old external-data-button component)
 */
var helpTextPopover = function (helpText) { return helpText ?
    React.createElement("div", { className: "help-text" },
        React.createElement(Popover, { inverted: true, trigger: React.createElement(Icon, { name: "info" }), content: helpText, position: "top center" }))
    : null; };
var ExternalField = function (props) {
    var id = props.id, required = props.required, formData = props.formData;
    var _a = props.schema, external_url = _a.external_url, popup_height = _a.popup_height, popup_width = _a.popup_width;
    var formContext = props.registry.formContext;
    var options = props.uiSchema['ui:options'];
    var helpText = options ? options.helpText : '';
    var handleExternalClick = props.handleExternalClick ? props.handleExternalClick : function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var externalUrl, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.preventDefault();
                    if (!(formContext && formContext.auth)) return [3 /*break*/, 2];
                    return [4 /*yield*/, formContext.auth.secureUrl(external_url)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = external_url;
                    _b.label = 3;
                case 3:
                    externalUrl = _a;
                    popupHelper.openPopup(externalUrl, popup_width, popup_height, function (err, result) {
                        if (err) {
                            console.log('error =', err);
                            return;
                        }
                        props.onChange(result);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    // Do we have a valid value already?
    var hasValidValue = false;
    if (typeof formData === 'number' && formData >= 0) {
        hasValidValue = true;
    }
    else if (formData && formData.length > 1) {
        hasValidValue = true;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "control-label", htmlFor: id },
            React.createElement("span", null,
                props.schema.title,
                " ",
                required ? '*' : null)),
        React.createElement("div", { className: "control-input" },
            React.createElement("div", { className: "control-input-field control-input-field__external", style: { textAlign: 'left' } },
                React.createElement("input", { disabled: props.disabled, type: "hidden", defaultValue: formData && formData.length > 0 ? formData : props.schema.default, readOnly: true }),
                helpTextPopover(helpText),
                React.createElement(Button, { disabled: props.disabled, onClick: handleExternalClick, className: formData && formData.length > 1 ? 'success' : '' }, hasValidValue && !props.hideCheck ? (React.createElement(React.Fragment, null,
                    React.createElement("span", null, "Logged In"),
                    React.createElement(Icon, { name: "checked-circle" }))) : (props.schema.button_text))))));
};
export default ExternalField;
//# sourceMappingURL=external-field.js.map